/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { useNavigate } from "react-router-dom";
import SecondaryHeading from "../Typography/SecondaryHeading";
import MainButton from "../MainButton/MainButton";
import AuxiliaryText from "../Typography/AuxiliaryText";
import SpecialText from "../Typography/SpecialText";
import Pro from "../Tags/Pro";

const SwiperCard = ({
  heading,
  text,
  Images,
  company,
  userProfile,
  userPlan,
  postId,
  userId,
  cardMarginClassName = "m-[1.125rem]",
  overlayPaddingClassName = "p-4 sm:p-5 md:p-6",
  contentRowGapClassName = "gap-x-3",
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div 
        className={`w-[200px] h-[250px] lg:w-[250px] lg:h-[320px] 2xl:w-[270px] 2xl:h-[340px] rounded-xl group/main relative cursor-pointer ${cardMarginClassName}`}
        onClick={() => {
          navigate({
            pathname: "/service-detail/",
            search: `?id=${postId}`,
          });
        }}
      >
        <div className={`absolute w-full h-full z-10 flex flex-col justify-between ${overlayPaddingClassName}`}>
          <div className="flex items-center justify-end">
            {/* {userPlan?.toLowerCase() === "pro" && (
              <div className="bg-primaryblue text-white px-[2px] pt-[1px]">
                <AuxiliaryText variant={"Infographic"}>Pro</AuxiliaryText>
              </div>
            )} */}
          </div>
          <div className={`flex ${contentRowGapClassName} cursor-pointer items-start`}>
            <div 
              className="group/profile relative shrink-0"
              onClick={(e) => {
                e.stopPropagation();
                navigate({
                  pathname: "/poster-profile/",
                  search: `?id=${userId}&name=${company}`,
                });
              }}
            >
              <img
                className="avatar-extra-small object-cover object-center shrink-0"
                src={
                  userProfile && userProfile !== "null"
                    ? userProfile
                    : require("../../../assets/img/default-image.jpg")
                }
                alt={company || "Profile"}
                onError={(e) => {
                  e.target.src = require("../../../assets/img/default-image.jpg");
                }}
              />
              {/* <div className="hidden lg:group-hover/profile:block absolute z-20"> */}
              <div className="hidden absolute z-20">
                <div
                  className={`bg-white -ml-2 -mt-[240px] w-[400px] h-[200px] rounded-xl p-5`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="relative">
                        <img
                          className="avatar-small object-cover object-center cursor-pointer"
                          src={require("../../../assets/img/User.png")}
                          // src={
                          //   !companyLogo || companyLogo === "null"
                          //     ? require("../../../assets/img/hero-vector.svg").default
                          //     : companyLogo
                          // }
                          alt={"no-image"}
                          // onError={(e) => {
                          //     e.target.src = require("../../assets/img/default-image.jpg");
                          //   }}
                        />
                        <div className="absolute -mt-3 left-[30%]">
                          <div className="b mt-[1px] mr-2">
                           <Pro className={"bg-primaryblue text-white"}/>
                          </div>
                        </div>
                      </div>
                      <div className="ml-3">
                        <div>
                          <SpecialText variant={"ProfileName"}>
                            Architecture
                            {/* {heading} */}
                          </SpecialText>
                        </div>
                        <div>
                          <SpecialText variant="ProfileMicro">
                            Duffy, ACT, 2611
                          </SpecialText>
                        </div>
                      </div>
                    </div>
                    <div>
                      <MainButton variant={"outlinesmall"}>
                        Follow
                      </MainButton>
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-5">
                    <div className="w-[109px] h-[82px]">
                      <img
                        src={require("../../../assets/img/default-image.jpg")}
                        className="w-full h-full rounded-xl object-center"
                        alt="portfolio"
                      />
                    </div>
                    <div className="w-[109px] h-[82px]">
                      <img
                        src={require("../../../assets/img/default-image.jpg")}
                        className="w-full h-full rounded-xl object-center"
                        alt="portfolio"
                      />
                    </div>
                    <div className="w-[109px] h-[82px]">
                      <img
                        src={require("../../../assets/img/default-image.jpg")}
                        className="w-full h-full rounded-xl object-center"
                        alt="portfolio"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-0 h-0 border-l-[10px] border-l-transparent border-t-[15px] border-t-white border-r-[10px] border-r-transparent ml-1"></div>
              </div>
            </div>
            <div className="flex flex-col">
              <SecondaryHeading
                variant={"BodyCompactHeading"}
                className={
                  "w-[85%] overflow-hidden text-ellipsis text-white break-all line-clamp-2 !font-normal"
                }
              >
                {heading}
              </SecondaryHeading>
            </div>
          </div>
        </div>
        <img
          className="h-full w-full object-cover rounded-xl opacity-90 "
          src={Images || require("../../../assets/img/default-image.jpg")}
          alt=""
        />
      </div>
    </>
  );
};

export default SwiperCard;
